import React from 'react'
import mainData from '../../FetchDataLinks'
import UseFetch from '../../UseFetch'
import CommentSubmitForm from '../Forms/CommentSubmitForm'
import SingleComment from './SingleComment'

function Comment({ id, cateogary, PostHead, hashtag1, slug }) {
    const { blogs, loading } = UseFetch(`${mainData.getComments}${id}`)
    return (
        <div className="row">
            <div className="col-lg-8">
                {!loading && <div className="comments">
                    <h3 className="aside-title ">Recent comments({blogs.length})</h3>
                    <div className="comments-grids">

                        {blogs.map((blog, index) => {
                            return <SingleComment key={index} slug={blog.slug} CommentorName={blog.name} CommentMessage={blog.message} date={blog.date} time={blog.Time} />
                        })}

                    </div>
                </div>}

                {id && <CommentSubmitForm idArticle={id} cateogary={cateogary} slug={slug} PostHead={PostHead} hashtag={hashtag1} />}

            </div>
        </div>
    )
}

export default Comment
